import {translationBaseKey} from '../decorators/translation-base-key.decorator';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('')
export class CreatePersonalClientOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Input
  })
  firstName: string;

  @advancedFormControl({
    type: FormControlTypeEnum.Input
  })
  lastName: string;
}